export const NEWS_TYPES = {
  BEST: 'best',
  LATEST: 'latest'
};

export const ROUTER_NAMES = {
  INDEX: 'index',
  HOME: 'home',
  USER_PROFILE: 'user-profile',
  USER_AVAILABLE_EVENTS: 'user-available-events',
  SUBSCRIBE_SUCCESS: 'user-event-subs-success',
  USER_ACTIVE_REGISTRATION: 'user-active-registration',
  USER_EVENT_REGISTER: 'user-event-register',
  ADMIN_HOME: 'admin-home',
  ADMIN_EVENTS_PARTICIPANTS: 'admin-events-participants',
  ADMIN_EVENTS_PARTICIPANTS_EDIT: 'admin-events-participants-edit',
  ADMIN_EVENTS_EDIT: 'admin-event-edit',
  ADMIN_EVENTS_DETAIL: 'admin-event-detail',
  ADMIN_EVENTS: 'events',
  ADMIN_EVENTS_GROUPS: 'events-groups',
  ADMIN_USERS: 'users',
  ADMIN_USERS_EDIT: 'users-edit',
  ADMIN_INDEX: 'admin-index',
  CONTACT: 'contact',
  REGISTRATION: 'registration',
  REGISTRATION_SUCCESS: 'registrationSuccess',
  NEWS_LIST: 'news-list',
  NEWS: 'news',
  NEWS_UNPUBLISHED: 'news-unpublished',
  NEWS_UNPUBLISHED_LIST: 'news-unpublished-list',
  NEWS_CREATE: 'create-news',
  NEWS_EDIT: 'edit-news',
  NEWS_MESSAGES_LIST: 'messages',
  NEWS_MESSAGES_DETAIL: 'messages-detail',
  PAGE: 'page',
  PAGE_EDIT: 'edit-page',
  PAGE_CREATE: 'create-page',
  PAGE_CREATE_PARENT: 'create-page-parent',
  PARENT_PAGE: 'parent-page',
  LOGIN: 'login',
  NOT_FOUND: 'notFound',
  ERROR: 'error',
  LOGOUT: 'logout',
  SLIDER_IMAGES: 'slider-images',
  SLIDER_IMAGES_EDIT: 'edit-slider-images',
  SLIDER_IMAGES_CREATE: 'create-slider-images',
  FORGOT_PASSWORD: 'forgot-password',
  FORGOT_PASSWORD_SUCCESS: 'forgot-password-success',
  RESET_PASSWORD: 'reset-password',
  VERIFICATION_EMAIL: 'verification-email',
  VERIFY_EMAIL: 'verify-email',
  VERIFY_EMAIL_EXPIRED: 'verify-email-failed',
  VERIFY_EMAIL_SUCCESS: 'verify-email-success'
};

export const API_ROOT = '/api';


export const ERROR_MESSAGES = {
  INTERNAL_SERVER_ERROR: 'errorMessages.INTERNAL_SERVER_ERROR',
  ALREADY_REGISTERED: 'errorMessages.ALREADY_REGISTERED',
  USER_ALREADY_EXIST: 'errorMessages.USER_ALREADY_EXIST'
};

// PROD
export const SITE_KEY_RECAPTCHA = "6LcVpqEUAAAAAETiGIh1JXLkG-mQEcSKaXtVr1Ro";
// DEV
// export const SITE_KEY_RECAPTCHA = "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";
